import { useMemo } from "react"
import { useRouterState } from "@tanstack/react-router"
import { resolveDocsSlug } from "./useHelpGuideUrl.utils"
import type { UseHelpGuideUrlReturn } from "./useHelpGuideUrl.types"

/**
 * Resolves the docs URL most relevant to the current route and provides a
 * helper to open it in a new tab. Falls back to the docs home page when the
 * current route has no explicit mapping.
 */
export const useHelpGuideUrl = (): UseHelpGuideUrlReturn => {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })

  const url = useMemo(() => {
    const docsBaseUrl = import.meta.env.VITE_MIMBER_DOCS_URL || ""
    const slug = resolveDocsSlug(pathname)
    return slug ? `${docsBaseUrl}/${slug}` : docsBaseUrl
  }, [pathname])

  const openHelpGuide = () => {
    if (!url) return
    window.open(url, "_blank", "noopener,noreferrer")
  }

  return { url, openHelpGuide }
}
